<app-network-status-info [status]="networkStatus$ | async" />
<router-outlet />
